import { submitOnlineBookingHomeThunk } from 'actions/onlineBooking/OnlineBookingActions';
import { heroGirlCombingDog } from 'assets/images';
import clsx from 'clsx';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { ActionButton } from 'components/UI/ActionButton/ActionButton';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOnlineBookingPreferences } from 'reducers/marketplace/MarketplaceSelectors';
import { OnlineBookingStep } from 'types/OnlineBooking';

import classes from './OnlineBookingHomeStep.module.scss';

export const OnlineBookingHomeStep: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useMarketplace();

    const olbPreferences = useSelector(getOnlineBookingPreferences);

    const submitHandler = (step: OnlineBookingStep) => {
        dispatch(submitOnlineBookingHomeThunk(step));
    };

    return (
        <>
            <LeftColumn contentClassName="flex flex-col flex-1">
                <>
                    <div className={classes.content}>
                        <MarketplaceInfo marketplace={marketplace} />

                        <h1 className={clsx('h1', 'underlined', classes.title)}>
                            Let&apos;s make an appointment
                        </h1>

                        {olbPreferences.allowNewClients && (
                            <ActionButton
                                title="New client"
                                description={`This is my first time booking with ${marketplace.name}`}
                                onClick={() => submitHandler(OnlineBookingStep.NewClientForm)}
                            />
                        )}
                        <ActionButton
                            title="Returning client"
                            description={`I’ve booked with ${marketplace.name} before 🐶`}
                            onClick={() => submitHandler(OnlineBookingStep.Signin)}
                        />
                    </div>

                    <div className="pt-6 mt-auto">
                        <PoweredByCuddles />
                    </div>
                </>
            </LeftColumn>

            <RightImageColumn image={olbPreferences.promoImageUrl ?? heroGirlCombingDog} />
        </>
    );
};
